enum EStatus {
  UNAUTHORIZED = 401,
}

export default EStatus;
